;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
export var expertToolkitApiUrl = '/_serverless/expert-toolkit';
export var createExpertToolkitApi = function (http) {
    var expertToolkitApiUrl = '/_serverless/expert-toolkit';
    var api = {
        searchUserAccountsByEmail: function (dto) {
            return http.post("".concat(expertToolkitApiUrl, "/searchUserAccountsByEmail"), dto);
        },
        getUserInfo: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getUserInfo?userId=").concat(dto.userId, "&accountId=").concat(dto.accountId));
        },
        checkVpn: function () {
            return http.get("".concat(expertToolkitApiUrl, "/checkVpn"));
        },
        getUserEssentials: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getUserEssentials?accountId=").concat(dto.accountId, "&userId=").concat(dto.userId, "&ticketId=").concat(dto.ticketId));
        },
        getAccountDetails: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getUserAccountDetails?accountId=").concat(dto.accountId, "&userId=").concat(dto.userId));
        },
        getTicketBrief: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getTicketBrief?ticketId=").concat(dto.ticketId, "&accountId=").concat(dto.accountId, "&userId=").concat(dto.userId));
        },
        getUserTicketHistoryStats: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getUserTicketHistoryStats?ticketId=").concat(dto.ticketId));
        },
        getTicketTechnicalData: function (dto) {
            return http.get("".concat(expertToolkitApiUrl, "/getTechicalData?ticketId=").concat(dto.ticketId));
        }
    };
    return api;
};
export * from './user-account-Info.builder';
export * from './account-Info.builder';
export * from './account-details.builder';
//# sourceMappingURL=index.js.map